import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from '../entity';
import { Filters } from './filters';
import { Sort } from './sortBy';

@JsonObject('request')
export class DataRequest extends Entity {
  @JsonProperty('queryName', String)
  public queryName?: string = undefined;
  @JsonProperty('filters', [Filters])
  public filters?: Filters[] = undefined;
  @JsonProperty('sortBy', [Sort])
  public sortBy?: Sort[] = undefined;
  @JsonProperty('page', Number)
  public page?: number = undefined;
  @JsonProperty('size', Number)
  public size?: number = undefined;
}

